import { render } from "./LoanItem.vue?vue&type=template&id=6dbdc495"
import script from "./LoanItem.vue?vue&type=script&lang=js"
export * from "./LoanItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__